import { Link } from 'react-router-dom'
import { Section, Badge } from '@vanilla/ui'
import { ArrowLeft } from 'lucide-react'

export function Music() {
  return (
    <Section className="py-20 md:py-32">
      <div className="flex flex-col items-center text-center">
        <Link
          to="/"
          className="mb-12 inline-flex items-center gap-2 text-sm text-muted-foreground transition-colors hover:text-foreground"
        >
          <ArrowLeft className="h-4 w-4" />
          KHC One
        </Link>

        <span className="mb-6 text-6xl">🎵</span>

        <h1 className="mb-4 text-4xl font-bold tracking-tight sm:text-5xl">
          KHC Music
        </h1>

        <p className="mb-8 text-lg text-muted-foreground">
          Artists, releases, and label operations
        </p>

        <Badge variant="secondary">Coming Soon</Badge>

        <p className="mt-16 text-sm text-muted-foreground">
          © 2025 KHC Music ·{' '}
          <Link to="/" className="text-primary hover:underline">
            KHC One
          </Link>
        </p>
      </div>
    </Section>
  )
}
